import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function UsersChart() {
  const [data, setData] = useState<{ role: string; count: number }[]>([]);
  const { schoolId } = useParams();

  useEffect(() => {
    const loadUsersCount = async () => {
      const { count: teacherCount, error: teacherError } = await supabase
        .from("profiles")
        .select("*", { count: "exact", head: true })
        .eq(schoolId ? "school_id" : "", schoolId || "")
        .eq("role", "teacher");

      // Count students
      const { count: studentCount, error: studentError } = await supabase
        .from("profiles")
        .select("*", { count: "exact", head: true })
        .eq(schoolId ? "school_id" : "", schoolId || "")
        .eq("role", "student");
      //   const { count: adminCount, error: adminError } = await supabase
      //     .from("profiles")
      //     .select("*", { count: "exact", head: true })
      //     .eq(schoolId ? "school_id" : "", schoolId || "")
      //     .eq("role", "school");

      //   if (teacherError || studentError) {
      //   }

      setData([
        { role: "المعلمون", count: teacherCount || 0 },
        { role: "الطلاب", count: studentCount || 0 },
        // { role: "Admins", count: adminCount },
      ]);
    };

    loadUsersCount();
  }, []);

  return (
    <div className="w-full h-64" dir="ltr">
      <ResponsiveContainer
        width="100%"
        height="100%"
        className={"dir-"}
        style={{ direction: "ltr" }}
      >
        <BarChart data={data}>
          <XAxis dataKey="role" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="count" fill="#3b82f6" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
